<template>
    <div class="trigger-selector">
        <p class="mb-0">
            <span v-if="label" class="caption grey--text text--darken-1">{{ label }}</span>

            <span
                v-if="additionalItems.length"
                class="caption format-label ml-2"
                :class="{'font-weight-bold active': displayDefaultFormat, 'grey--text text--darken-1': !displayDefaultFormat}"
                @click="displayDefaultFormat = true"
            >{{indexname + '_DEFAULT_FORMAT_LABEL' | translation}}</span>

            <span
                v-if="additionalItems.length"
                class="caption format-label ml-2"
                :class="{'font-weight-bold active': !displayDefaultFormat, 'grey--text text--darken-1': displayDefaultFormat}"
                @click="displayDefaultFormat = false"
            >{{indexname + '_ADDITIONAL_FORMAT_LABEL' | translation}}</span>
        </p>

        <v-btn
            v-for="item in itemsToRender"
            :key="`${displayDefaultFormat?'default':'additional'}-${item.value}`"
            :color="value === item.value ? selectedColor : defaultColor"
            @click="$emit('input', item.value)"
            :disabled="!isItemAvailable(item.value)"
            :outline="value !== item.value"
        >
            {{item.text}}
        </v-btn>

        <div
            v-if="$language.translate(indexname + '_PRODUCT_LINK') !== indexname + '_PRODUCT_LINK' || true"
            class="link-content"
        >
            <v-icon class="black--text">{{icon}}</v-icon>
            <page-modal
                :link="'/attribute-type/' + indexname"
                class="info-link caption ml-1"
            >{{indexname + '_PRODUCT_LINK' | translation}}</page-modal>
        </div>
    </div>
</template>

<style scoped>
    .format-label {
        cursor: pointer;
    }
    .format-label:not(.active) {
        text-decoration: underline;
    }
    .trigger-selector .v-btn {
        margin-left: 0;
        margin-right: 16px;
    }
    .link-content {
        display: flex;
        align-items: center;
    }
</style>

<style>
    .info-link .inner-content {
        color: inherit !important;
        text-decoration: underline;
        text-transform: uppercase;
    }
</style>

<script>
    export default {
        name: 'TriggerSelector',
        props: {
            label: String,
            indexname: String,
            value: null,
            items: {
                type: Array,
                default: [],
            },
            availableItems: {
                type: Array,
                default: [],
            },
            additionalItems: {
                type: Array,
                default: [],
            },
            selectedColor: {
                default: 'primary'
            },
            defaultColor: {},
            icon: String,
        },
        data() {
            return {
                displayDefaultFormat: true,
            };
        },
        computed: {
            itemsToRender() {
                return this.displayDefaultFormat ? this.items : this.additionalItems;
            },
        },
        methods: {
            isItemAvailable(value) {
                let available = false;

                for (const availableItem of this.availableItems) {
                    if (availableItem.value === value) {
                        if (availableItem.buyable) {
                            available = true;
                        }
                        break;
                    }
                }

                return available;
            },
        },
    };
</script>